import {useEffect} from "react";
import {t} from "@lingui/macro";

import {theme} from "Theme";
import {useMapContext} from "base/map";
import {IsocronasMapActionsToolbar, IsocronasMapCategoriesSelector} from ".";

import styled from "@mui/material/styles/styled";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";

import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import {MapGeojsonLayerFeatureListProvider} from "base/map/layer/geojson";
import {MapTOC} from "base/map/toc";
import {PoisMapFeatureList} from "poi/map";
import IsocronasFilterSelector from "./IsocronasFilterSelector";

const TRANSITION_TIME = 200;

const SideBarContainer = styled("div", {
    shouldForwardProp: prop => prop !== "open",
})(({theme, style, open}) => {
    return {
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
        height: "100%",
        boxShadow: theme.shadows[2],

        transition: theme.transitions.create("width", {
            easing: theme.transitions.easing.sharp,
            duration: TRANSITION_TIME,
        }),
        width: 0,
        ...(open && {
            transition: theme.transitions.create("width", {
                easing: theme.transitions.easing.easeOut,
                duration: TRANSITION_TIME,
            }),
            width: "100%",
        }),
        borderRadius: 5,
        backgroundColor: theme.palette.pageBackground.secondary,
        ...style,
    };
});

const ToggleSideBarButton = ({showToc, onClick}) => {
    return (
        <Box
            sx={{
                position: "relative",
                top: 6,
                right: showToc ? 90 : 6,
                zIndex: 1,
                // width: 0,
                height: 40,
                ml: 1,
            }}
        >
            <Tooltip title={t`${showToc ? "Mostrar" : "Ocultar"} menu`}>
                <IconButton
                    onClick={onClick}
                    color="primary"
                    sx={{
                        p: 0.5,
                        background: "rgba(230, 217, 199, 0.8)",
                        boxShadow: theme.shadows[2],
                    }}
                >
                    {showToc ? (
                        <KeyboardDoubleArrowLeftIcon />
                    ) : (
                        <KeyboardDoubleArrowRightIcon />
                    )}
                </IconButton>
            </Tooltip>
        </Box>
    );
};

const IsocronasMapControlPanel = ({show = true}) => {
    const {showToc, setShowToc, mapObjectRef} = useMapContext();

    useEffect(() => {
        // Timeout necessary to wait for the end of the transition
        // so map could calculate the new size
        setTimeout(() => {
            mapObjectRef.current.invalidateSize();
        }, TRANSITION_TIME);
    }, [showToc]);

    return (
        <Stack
            direction="row"
            sx={{
                position: "absolute",
                top: 0,
                left: 0,
                maxWidth: 400,
                height: "100%",
                zIndex: 1,
                py: 1,
                pl: 1,
            }}
        >
            <MapGeojsonLayerFeatureListProvider>
                <SideBarContainer open={show && showToc}>
                    <IsocronasMapActionsToolbar />
                    <MapTOC visible={false} />
                    <IsocronasFilterSelector />
                    <IsocronasMapCategoriesSelector />
                    <PoisMapFeatureList />
                </SideBarContainer>
            </MapGeojsonLayerFeatureListProvider>
            {show && (
                <ToggleSideBarButton
                    showToc={showToc}
                    onClick={() => {
                        setShowToc(!showToc);
                    }}
                />
            )}
        </Stack>
    );
};

export default IsocronasMapControlPanel;
